lmApp
  .service('ModalWindowService', ['$rootScope', '$templateCache', '$compile', '$location',
    function ($rootScope, $templateCache, $compile, $location) {

      //
      // PRIVATE MEMBERS
      //
      var ScopesList = [];
      var windowContainer;
      var overlay;
      var _window_ = angular.element(window);

      windowContainer = angular.element('<div id="modal_container">' +
        '<div id="lean-overlay"></div></div>');
      overlay = windowContainer.find('#lean-overlay');
      overlay.css({opacity: 0.8});
      angular.element('body').append(windowContainer);

      var _CreateAction = function (action, modalScope) {

        var elem = angular.element('' +
          '<a class="modal-action modal-close mh mv btn-flat ' + (action.className || '') +
          ' tc-' + (action.color || 'black') + '-600" ' +
          'lm-waves="' + (action.color || 'grey') + '-600"> ' +
          (action.title || 'Action') + ' </a>');

        elem = $compile(elem)(modalScope);

        elem.bind('click', function () {
          if (action.check && !action.check()) {
            return;
          }

          if (action.fn) {
            action.fn();
          }

          Close(modalScope, true);
        });

        elem.bind('$destroy', function () {
          elem.unbind('click');
        });

        return elem;
      };

      var _onKeyDown = function (event) {
        var key = event.which;

        if (key === 27) {
          if (event.preventDefault) event.preventDefault();
          if (event.stopPropagation) event.stopPropagation();

          if (ScopesList.length) {
            Close(_.pullAt(ScopesList, ScopesList.length - 1)[0], false);
          }

          return false;

        }
      };

      _window_.bind('keydown', _onKeyDown);

      /**
       *
       * @param options {
       *     content: DOMNode,
       *     navigation: DOMNode,
       *     actions: Array.{
       *       className: String - Additional class
       *       title: String,
       *       color: String,
       *       fn: Function,
       *       check: Function -> return Boolean if passed
       *     },
       *     onInit: Function
       *     onComplete: Function(result),
       *     size: {
       *       s: Number,
       *       m: Number,
       *       l: Number
       *     },
       *     isFixed: Boolean,
       *     keyboard: Boolean - close on keyboard events
       *     clear: Boolean - with out padding,
       *     clearRoute: Array - clear route after close
       * @returns {*} $scope
       */
      var Open = function (options) {
        var modalScope = $rootScope.$new(false);
        modalScope.depth = ScopesList.length;

        modalScope._id = 'modal_' + Date.now() + parseInt(Math.random() / 1000, 10);

        modalScope._modal_element_ = $templateCache.get('lm-modal-window/lm-modal-window.tpl.html');

        modalScope._modal_element_ = $compile(modalScope._modal_element_)(modalScope);
        modalScope._modal_element_.attr('id', modalScope._id);
        windowContainer.append(modalScope._modal_element_);

        modalScope._navigation_element_ = modalScope._modal_element_.find('.modal-navigation');
        modalScope._content_element_ = modalScope._modal_element_.find('.modal-content');
        modalScope._fotter_element_ = modalScope._modal_element_.find('.modal-footer');

        if (modalScope.depth) {
          modalScope._empty_ = angular.element('<div id="empty" style="opacity: 0.8;"></div>');
          windowContainer.append(modalScope._empty_);
        }

        if (options.size) modalScope.size = options.size;

        modalScope._content_element_.css({visibility: 'hidden'});

        if (options.content) {
          if (options.clear) {
            modalScope._content_element_.addClass('p0');
          }
          modalScope._content_element_.html(options.content);
        }

        if (options.navigation) {
          modalScope._navigation_element_.html(options.navigation);
        }

        if (options.keyboard) modalScope.isKeyevent = true;

        modalScope.clear = options.clear;
        modalScope.clearRoute = options.clearRoute;

        modalScope.withActions = options.actions && options.actions.length;

        if (options.actions) {
          options.actions.forEach(function (action) {
            modalScope._fotter_element_.append(_CreateAction(action, modalScope));
          });
        }

        if (options.onComplete) {
          modalScope.FinalCallback = options.onComplete;
        } else {
          modalScope.FinalCallback = function () {
          }
        }

        if (options.onInit) {
          modalScope.InitCallback = options.onInit;
        } else {
          modalScope.InitCallback = function () {
          }
        }

        if (options.isFixed) modalScope.isFixed = true;

        modalScope._CSS = {
          display: 'block'
        };

        modalScope._modal_element_.css({
          top: 5 - modalScope.depth * 2 + '%',
          'z-index': _.size(ScopesList) + 1000
        });

        TweenMax
          .from(modalScope._modal_element_, 0.35, {
            top: '0px',
            ease: Expo.easeInOut,
            onComplete: function () {

              modalScope._modal_element_.css({
                top: 5 - modalScope.depth * 2 + '%',
                display: 'block'
              });

              modalScope._content_element_.css({
                visibility: 'visible',
                maxHeight: _window_.height() * 0.9
              });


              if (modalScope._empty_) modalScope._empty_.css({
                'z-index': (Number(modalScope._modal_element_.css('z-index')) - 1)
              });

              modalScope.InitCallback();
            }
          });

        TweenMax
          .to(overlay, 0.35, {
            display: 'block',
            opacity: 0.5,
            ease: Expo.easeInOut
          });

        modalScope.offset = window.pageYOffset;

        angular.element('body').css({
          top: -modalScope.offset + 'px'
        });

        angular.element('body').addClass('modal-is-open');

        modalScope.onResize = function () {

          if (modalScope.fullscreen) {
            modalScope._modal_element_.find('.modal-content').css({maxHeight: _window_.height(), height: '100%'});
          } else {
            modalScope._modal_element_.find('.modal-content').css({maxHeight: _window_.height() * 0.9});
          }
        };

        _window_.bind('resize', modalScope.onResize);

        ScopesList.push(modalScope);

        return modalScope;
      };

      var Close = function (modalScope, result) {
        if (!modalScope || !modalScope._modal_element_) return;

        TweenMax
          .to(modalScope._modal_element_, 0.45, {
            top: '-200px',
            ease: Expo.easeInOut,
            onComplete: function () {
              //delete ScopesList[modalScope._id];
              angular.element('body').unbind('resize', modalScope.onResize);

              modalScope._modal_element_.remove();

              if (ScopesList.indexOf(modalScope) !== -1) {
                ScopesList.splice(ScopesList.indexOf(modalScope), 1);
              }

              if (ScopesList.length < 1) {
                overlay.css({display: 'none'});
                angular.element('body').removeAttr('style');
                angular.element('body').removeClass('modal-is-open');

                _window_.scrollTop(modalScope.offset);
              }

              if (modalScope._empty_) modalScope._empty_.remove();

              if (modalScope.clearRoute && modalScope.clearRoute.length) {
                modalScope.clearRoute.forEach(function (route) {
                  $location.search(route, null);
                });
              }

              modalScope.$destroy();
            }
          });

        modalScope.FinalCallback(!!result);
      };

      var Fullscreen = function (modalScope, state) {
        if (typeof state !== 'undefined') {
          modalScope.fullscreen = state;
        } else {
          modalScope.fullscreen = !modalScope.fullscreen;
        }

        modalScope.onResize();
      };

      // Public API
      return {
        Open: Open,
        Close: Close,
        Fullscreen: Fullscreen
      }
    }]);
